import { Component, OnInit, ViewChild } from '@angular/core';
import { JobData } from './catalouge-careers.model';
import { ListJobComponent } from './list-job/list-job.component';

@Component({
  selector: 'app-catalouge-careers',
  templateUrl: './catalouge-careers.component.html',
  styleUrls: ['./catalouge-careers.component.scss'],
})
export class CatalougeCareersComponent implements OnInit {
  @ViewChild(ListJobComponent, { static: false })
  listJobComponent: ListJobComponent;

  activeJobData = new JobData();

  constructor() {}

  ngOnInit() {}

  public onJobEdit(data: JobData) {
    this.activeJobData = data;
  }

  public onRefresh() {
    if (this.listJobComponent) {
      this.listJobComponent.readPostedJobs();
    }
  }
}
